export { MdbTabComponent } from './tab.component';
export { MdbTabContentDirective } from './tab-content.directive';
export { MdbTabTitleDirective } from './tab-title.directive';
export { MdbTabsComponent } from './tabs.component';
export { MdbTabsModule } from './tabs.module';
export { MdbTabPortalOutlet } from './tab-outlet.directive';
export { MdbTabChange } from './tabs.component';
